import { useStaticQuery, graphql } from "gatsby"

export const useFooterMenuQuery = () => {
  const data = useStaticQuery(graphql`
    query FooterQuery {
      allWpPost(limit: 3) {
        nodes {
          id
          title
          uri
        }
      }
    }
  `)

  return data
}
